export default {
    waypointNo: 'Номер пункта',
    addAction: 'Добавить действие',
    saveAction: 'Сохранить действие',
    waitForCompletion: 'Ожидание завершения',
    PTZAction: 'Облачные движения',
    PTZTilt: 'заострения тангажа облачной платформы',
    PTZHeading: 'курсовой угол облачной платформы',
    PTZModeSwitch: 'Переключение облачного режима',
    PTZHeadFollows: 'Облачная головка',
    PTZPositionKeeping: 'Облако удерживается',
    cameraAction: 'Действие камеры',
    photograph: 'Фотографии',
    startRecording: 'Запись',
    endRecording: 'Завершение записи',
    zoom: 'Фокус',
    isochronousPhotography: 'Фотографируйте',
    isometricPhotography: 'Изометрические снимки',
    endTakingPictures: 'Заканчивай фотографировать',
    pagerAction: 'Действие микрофона',
    pagerStartsPlaying: 'Звонок включен',
    pagerStopsPlaying: 'Крик выключен',
    throwerAction: 'Действие сбрасывателя',
    throwerDisengaged: 'Сброс сбрасывателя',
    waterPumpAction: 'Действие насоса',
    waterPumpOn: 'Насос включен',
    waterPumpOff: 'Закрытие насоса',
    audioFrequency: 'Аудио',
    lifeDetectionAction: 'Обнаружение жизни',
    lifeDetectionBegins: 'Обнаружение жизни начинается',
    lifeDetectionEnd: 'Обнаружение жизни завершено',
}